'use strict';
const errorHandler = require('./error-handler');

class ParamsManager {
  constructor(pathParams = [], bodyParams = {}, queryParams = [], headerParams = {}) {
    this.pathParams = pathParams;
    this.bodyParams = bodyParams;
    this.queryParams = queryParams;
    this.headerParams = headerParams;
  }

  addHeaderParams(header, value) {
    this.headerParams[header] = value;
    return this;
  }

  getHeaderParams() {
    return this.headerParams;
  }

  addPathParam(pathParam) {
    if (pathParam) {
      if (typeof pathParam === 'object') {
        throw errorHandler.handleError('The param can not be an object or an array');
      }
      this.pathParams.push(pathParam);
      return this;
    }
    throw errorHandler.handleError('Pass a param to the addPathParam function');
  }

  getPathParams() {
    return this.pathParams;
  }

  addBodyParams(bodyParam) {
    if (typeof bodyParam !== 'object') {
      throw errorHandler.handleError('bodyParams must be an object');
    }
    this.bodyParams = bodyParam;
    return this;
  }

  getBodyParams() {
    return this.bodyParams;
  }
  /* ...args is an array with all the parameters
  passed to the function */
  addQueryParam(...args) {
    for (let index = 0; index < args.length; index++) {
      if (typeof args[index] !== 'object') {
        throw errorHandler.handleError('queryParam must be inside an object');
      }
      this.queryParams.push(args[index]);
    }
    return this;
  }

  getQueryParams() {
    return this.queryParams;
  }

  getRequestParams() {
    return {
      pathParams: this.getPathParams(),
      bodyParams: this.getBodyParams(),
      queryParams: this.getQueryParams(),
      headerParams: this.getHeaderParams(),
    };
  }

}

module.exports = ParamsManager;
